import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import red from '@material-ui/core/colors/red';
import { Auth } from 'aws-amplify';
import { validateEmail } from '../helpers/validators';
import LoaderButton from '../components/LoaderButton';
import PasswordResetConfirmationForm from '../components/PasswordResetConfirmationForm';
import ContentHeader from '../components/ContentHeader';
import globalStyles from '../styles';

const styles = theme => ({
    root: {
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '800px',
        margin: '40px auto',
        padding: '0 10px 20px'
    },
    input: {
        margin: '0 20px 10px'
    },
    button: {
        width: '200px',
        height: '56px',
        marginBottom: '30px'
    },
    error: {
        margin: '0 20px 10px',
        color: red[500],
        minHeight: '20px'
    },
    register: {
        fontSize: '1em',
        marginBottom: '2em'
    },
    link: {
        ...globalStyles.link,
        fontWeight: 'bold'
    }
});

class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            error: '',
            loading: false,
            showConfirmation: false
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value,
            error: false
        });
    };

    handleSubmit = async event => {
        event.preventDefault();
        const { email } = this.state;

        this.setState({ loading: true });

        try {
            let codeLastSent = '';

            try {
                codeLastSent = window.localStorage.getItem('forgot_code_sent');
            } catch (localStorageErr) {
                console.error(localStorageErr);
            }

            if (
                !codeLastSent ||
                moment(codeLastSent) < moment().subtract(60, 'minutes')
            ) {
                await Auth.forgotPassword(email.toLowerCase());
                try {
                    window.localStorage.setItem(
                        'forgot_code_sent',
                        new Date().toISOString()
                    );
                } catch (localStorageErr) {
                    console.error(localStorageErr);
                }
            }

            this.setState({
                loading: false,
                showConfirmation: true
            });
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            });
        }
    };

    validateForm() {
        const { email } = this.state;
        return validateEmail(email);
    }

    renderResetForm() {
        const { classes } = this.props;
        const { email, error, loading } = this.state;

        return (
            <div className={classes.root}>
                <ContentHeader text="Reset password" id="login-header" />
                <form className={classes.form} onSubmit={this.handleSubmit}>
                    <Typography variant="body1" className={classes.register}>
                        Forgot your password? Enter your email address to reset
                        your login details.
                    </Typography>
                    <TextField
                        autoFocus
                        autoComplete="email"
                        className={`${classes.input} input`}
                        id="email"
                        type="email"
                        label="Email"
                        value={email}
                        onChange={this.handleChange}
                        variant="outlined"
                    />
                    <Typography className={classes.error}>{error}</Typography>
                    <div className={classes.buttons}>
                        <LoaderButton
                            variant="outlined"
                            color="primary"
                            disabled={!this.validateForm()}
                            className={classes.button}
                            type="submit"
                            isLoading={loading}
                            text="Reset password"
                            loadingText="Submitting..."
                        />
                    </div>
                </form>
            </div>
        );
    }

    render() {
        const { handleAuth } = this.props;
        const { email, showConfirmation } = this.state;

        return (
            <div className="Login">
                {!showConfirmation ? (
                    this.renderResetForm()
                ) : (
                    <PasswordResetConfirmationForm
                        email={email}
                        handleAuth={handleAuth}
                    />
                )}
            </div>
        );
    }
}

ForgotPassword.propTypes = {
    handleAuth: PropTypes.func.isRequired,
    classes: PropTypes.shape().isRequired
};

export default withStyles(styles)(ForgotPassword);
